// Routes toevoegen in App.js, binnen <Routes> (achter de bestaande login-bescherming):
//
//   import { singhRoutes } from "./singh/routes";
//   ...
//   <Routes>
//     ...bestaande routes...
//     {singhRoutes(logout)}
//   </Routes>
//
// En in het kassascherm (/kassa) de bestaande kassier-knop rechtsboven vervangen door:
//   import KassierMenu from "./singh/components/KassierMenu";
//   <KassierMenu onAfmelden={logout} />
//
// En de knop "Z-ticket afdrukken & dag afsluiten" moet (na het afdrukken) aanroepen:
//   import { api } from "./singh/api";
//   await api.post("/dagontvangsten/afsluiten");
import { Route } from "react-router-dom";
import DagontvangstenVandaag from "./pages/DagontvangstenVandaag";
import Bestellingen from "./pages/Bestellingen";
import { BeheerCentralisatie, BeheerDagboek, BeheerPdfArchief, BeheerZTickets } from "./pages/Beheer";
import CodeSlot from "./components/CodeSlot";

export function singhRoutes(onAfmelden) {
  return [
    <Route key="dag" path="/dagontvangsten" element={<CodeSlot><DagontvangstenVandaag onAfmelden={onAfmelden} /></CodeSlot>} />,
    <Route key="best" path="/bestellingen" element={<CodeSlot><Bestellingen onAfmelden={onAfmelden} /></CodeSlot>} />,
    <Route key="bd" path="/beheer/dagboek" element={<CodeSlot><BeheerDagboek onAfmelden={onAfmelden} /></CodeSlot>} />,
    <Route key="bz" path="/beheer/z-tickets" element={<CodeSlot><BeheerZTickets onAfmelden={onAfmelden} /></CodeSlot>} />,
    <Route key="bp" path="/beheer/pdf" element={<CodeSlot><BeheerPdfArchief onAfmelden={onAfmelden} /></CodeSlot>} />,
    <Route key="bc" path="/beheer/centralisatie" element={<CodeSlot><BeheerCentralisatie onAfmelden={onAfmelden} /></CodeSlot>} />,
  ];
}
